<template lang="html">
  <div class="toast">
    <span>{{message}}</span>
    <button v-if="actionLabel" @click="execute">{{actionLabel}}</button>
    <button v-else aria-label="Close" class="icon" @click="remove"><Icon icon="cross"/></button>
  </div>
</template>

<script>
import Icon from './Icon.vue';

export default {
  components: {
    Icon,
  },
  data() {
    return {
      autoRemove: null,
    };
  },
  methods: {
    execute() {
      if (this.action) this.action();
      this.remove();
    },
    remove() {
      if (this.autoRemove) window.clearTimeout(this.autoRemove);
      this.$emit('remove');
    },
  },
  mounted() {
    if (this.timeout > 0) this.autoRemove = window.setTimeout(this.remove, this.timeout);
  },
  props: {
    action: Function,
    actionLabel: String,
    message: String,
    timeout: Number,
  },
};
</script>

<style lang="stylus" scoped>
@require '../styles/colors'
@require '../styles/shadows'

.toast
  background-color: $text
  color: $black
  border-radius: 12px
  padding: 12px
  display: flex
  align-items: center
  min-height: 60px
  margin-bottom: 8px
  box-shadow: $interactable-shadow

  span
    font-size: 0.875rem
    font-weight: normal
    margin-right: 16px
    width: 100%
    text-shadow: 0 1px rgba(0,0,0,0.25)
    line-height: 1.1rem
    overflow-wrap: break-word
    word-wrap: break-word
    word-break: break-all
    word-break: break-word
    hyphens: auto

  button
    flex-shrink: 0
    margin: 0
    background-color: transparent
    font-family: inherit
    font-size: 0.75rem
    font-weight: 600
    text-transform: uppercase
    letter-spacing: 1px
    text-shadow: 0 1px rgba(0,0,0,0.25)
    border: none
    color: $selection

    &.icon
      width: 36px
      height: @width
      padding: 9.5px
</style>
